"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PaginationTable_1 = require("../PaginationTable");
var monthlystatement_1 = require("../../api/monthlystatement");
var react_1 = require("react");
require("../../styles/CustomerListPage.css");
require("../../styles/MonthlyStatementPage.css");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var react_moment_1 = require("react-moment");
var customerListColumns = [
    {
        Header: 'Invoice',
        accessor: 'statementNum'
    },
    {
        Header: 'Date',
        accessor: 'statementDate',
        Cell: function (row) { return (React.createElement(React.Fragment, null,
            React.createElement(react_moment_1.default, { format: "DD MMM YYYY" }, row.value))); }
    },
    {
        Header: 'Amount',
        accessor: 'grandTotal',
        Cell: function (row) { return (React.createElement(React.Fragment, null,
            "RM",
            row.value)); }
    },
    {
        Header: 'Status',
        accessor: 'status'
    },
    {
        Header: 'Action',
        accessor: 'statementId',
        Cell: function (row) { return (React.createElement(React.Fragment, null,
            React.createElement("a", { className: "padding-default", href: '/statement-detail/' + row.value },
                React.createElement("img", { src: "./visibility.svg", className: "font-icon" })))); }
    }
];
var handleEdit = function (row) {
    console.log(row);
};
var handleDelete = function (row) { };
exports.default = (function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = msal_react_1.useMsal().inProgress;
    var columns = customerListColumns;
    var _a = react_1.useState(new Array()), list = _a[0], setList = _a[1];
    var _b = react_1.useState(false), isLoaded = _b[0], setIsLoaded = _b[1];
    var onLoad = function () {
        monthlystatement_1.fetchStatementsByCompany(props.companyId).then(function (response) {
            console.log('fetchStatement');
            setList(response.list);
            setIsLoaded(true);
        }).catch(console.error);
    };
    react_1.useEffect(function () {
        if (!isLoaded && inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [inProgress, list, setList, isLoaded, setIsLoaded]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "card-header" }),
            React.createElement("div", { className: "tableContainer monthlyStatementTable" }, list ? React.createElement(PaginationTable_1.PaginationTable, { columns: columns, data: list }) : React.createElement(React.Fragment, null, "Loading...")))));
});
//# sourceMappingURL=MonthlyStatementPage.js.map